import moment from 'moment'
import {
  AdditionalFieldsPayloadItem,
  CreateShiftPayload,
  PlanningAssistantPeriodicityPayload, PlanningDetailsPayload
} from '@/types/payload'
import { ShiftAvailability } from '@/types/enums'
import { PlannedEmployee } from '@/model/planning/PlannedEmployee'
import { ShiftTemplate } from '@/model/planning/ShiftTemplate'

export function composeCreateNewShiftPayload (
  profitCenterId: number,
  departmentId: number,
  creatingUserId: number,
  languageId: number,
  dateStart: Date,
  dateEnd: Date,
  periodicity: PlanningAssistantPeriodicityPayload,
  availability: ShiftAvailability,
  shiftTemplate: ShiftTemplate | undefined,
  addressId: number | null,
  referenzProjektId: number | null,
  abonnementId: number | null,
  additionalFields: AdditionalFieldsPayloadItem[],
  plannedEmployeeList: PlannedEmployee[]
): CreateShiftPayload {

  const format = 'YYYY/MM/DD HH:mm'
  const dateStartFormatted = moment(dateStart).format(format)
  const dateEndFormatted = moment(dateEnd).format(format)
  const expireAfterDateFormatted = moment(periodicity.expireAfterDate).format(format)

  let planningDetails: PlanningDetailsPayload[] = plannedEmployeeList.map((item: PlannedEmployee, rowIdx: number): PlanningDetailsPayload => {
    return {
      SchichtID: shiftTemplate ? shiftTemplate.id : null,
      ProjektSerie: 0,
      datumStart:  moment(item.start, 'DD/MM/YYYY HH:mm').format('YYYY/MM/DD HH:mm'),
      datumEnde :moment(item.end, 'DD/MM/YYYY HH:mm').format('YYYY/MM/DD HH:mm'),
      MitarbeiterID: item.id && item.id || null,
      NotizElement: item.note || '',
      ArbeitID: item.taskId ? item.taskId : null,
      fixiert: availability === ShiftAvailability.Fixed ? true : false,
      number: rowIdx + 1,
      Abteilung: departmentId,
      Zeile: rowIdx + 1
    }
  })

  return {
    Action: '',
    SchichtName: shiftTemplate ? shiftTemplate.description : '',
    ProfitCenter: profitCenterId,
    Abteilung: departmentId,
    Sachbearbeiter: creatingUserId,
    ReferenzTermin: dateStartFormatted,
    Montag: (periodicity.weekDayList.includes(1)),
    Dienstag: (periodicity.weekDayList.includes(2)),
    Mittwoch: (periodicity.weekDayList.includes(3)),
    Donnerstag: (periodicity.weekDayList.includes(4)),
    Freitag: (periodicity.weekDayList.includes(5)),
    Samstag: (periodicity.weekDayList.includes(6)),
    Sonntag: (periodicity.weekDayList.includes(7)),
    Whlg: periodicity.isUnique ? 0 : periodicity.repeatEveryNthWeek,
    Einmalig: periodicity.isUnique,
    Sprache: languageId,
    EndAfternTimes: periodicity.expireAfterRepetitions > 0 ? periodicity.expireAfterRepetitions : null,
    EndAfterDate: periodicity.expireAfterDate ? expireAfterDateFormatted : null,
    Provisorich: availability === ShiftAvailability.Temporary ? true : false,
    Fixiert: availability === ShiftAvailability.Fixed ? true : false,
    Notiz: '',
    DatumStart: dateStartFormatted,
    DatumEnde: dateEndFormatted,
    SchichtID: shiftTemplate ? shiftTemplate.id : null, //''
    AdressID: addressId, //''
    ReferenzProjektID: referenzProjektId,
    AbonnementID: abonnementId,
    Zusatzfelder: additionalFields,
    PlanningDetails: planningDetails
  }
}

export function composeAddEmployeeToShiftPayloadForFastPlanning (
  templateItem: ShiftTemplate, shiftAvailability: ShiftAvailability, rowNumber: number,
  employeeId: number, selectedDate: Date, departmentId: number
): PlanningDetailsPayload[] {
  const dateStart: string = moment(moment(selectedDate)
    .hour(templateItem.startDate.getHours())
    .minute(templateItem.startDate.getMinutes())
    .second(0)).toISOString()

  const dateEnd: string = moment(moment(selectedDate)
    .hour(templateItem.endDate.getHours())
    .minute(templateItem.endDate.getMinutes())
    .second(0)).toISOString()

  return [{
    SchichtID: templateItem ? templateItem.id : null,
    ProjektSerie: 0,
    datumStart:  moment(dateStart).format('YYYY/MM/DD HH:mm'),
    datumEnde :moment(dateEnd).format('YYYY/MM/DD HH:mm'),
    MitarbeiterID: employeeId && employeeId || null,
    NotizElement: '',
    ArbeitID: null,
    fixiert: false,
    number: rowNumber,
    Abteilung: departmentId,
    Zeile: rowNumber
  }]
}
